import React from 'react'

import { Box, Button, Form, Spinner } from '@factorialco/deprecated-design-system'

import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import type { Tag } from 'modules/ats/hooks/tags/useTags'
import { useUpdateTag } from 'modules/ats/hooks/tags/useUpdateTag'

import { DeleteTagModal } from './DeleteTagModal'

interface Props {
  tag: Tag
}

export const TagItem = ({ tag }: Props) => {
  const [name, setName] = React.useState(tag.name)
  const [deleteModalOpen, setDeleteModalOpen] = React.useState(false)
  const [isModalLoading, setIsModalLoading] = React.useState(false)
  const handleModalStatus = (loading: boolean) => setIsModalLoading(loading)
  const toggleModal = () => setDeleteModalOpen(!deleteModalOpen)

  const { loading: updating, update } = useUpdateTag(tag, {
    onCompleted() {
      app.setFlash({ type: 'correct', message: i18n.t('common.saved_successfully'), time: 2000 })
    },
  })

  const onTagEdit = () => {
    if (updating) return

    return update({ name })
  }

  const isDirty = name !== tag.name

  return (
    <Box gap={isDirty ? 's8' : 's16'} flexDirection="row" alignItems="center" width="full">
      <Form onSubmit={onTagEdit} padding={null}>
        <Box gap="s16" flexDirection="row" alignItems="center">
          <TextField key={tag.name} value={name} onChange={setName} />
          {isDirty && (
            <Button disabled={updating} submit>
              {i18n.t('common.save')}
            </Button>
          )}
        </Box>
      </Form>

      <Box width="s40" alignItems="center" justifyContent="center">
        {deleteModalOpen && isModalLoading ? (
          <Spinner size="s24" />
        ) : (
          <Button
            type="secondary"
            aria-label={i18n.t('ats.tags.delete.button', { tagName: tag.name })}
            disabled={deleteModalOpen}
            onClick={toggleModal}
            iconName="delete"
          />
        )}
      </Box>

      {deleteModalOpen && (
        <DeleteTagModal tag={tag} onClose={toggleModal} onLoad={handleModalStatus} />
      )}
    </Box>
  )
}
